import { Button, Dialog } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import BottomFloat from "../components/containers/BottomFloat";
import RetailerAccountTemplate from "../components/RetailerAccountTemplate";
import Withhold from "../components/Withhold";
import { logout } from "../redux/items/LoginReducer";
import { useDispatch, useSelector } from "react-redux";
import FetchLogin from "../components/Fetch/FetchLogin";
import { setLoadingPage } from "../redux/items/PageLoading";

import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Confirm from "../components/Confirm";
import {
  fourDPlaceBetAppendBoard,
  fourDPlaceBetSetBoard,
} from "../redux/items/FourDPlaceBet";
import {
  appendTotoPlaceBet,
  setTotoPlaceBet2,
} from "../redux/items/TotoPlaceBet";

export default function RetailerAccount() {
  const hist = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.login.token);

  const [v, setV] = useState({
    dialogLoadWishList: false,
    wishList: [],

    dialogDeleteWishList: false,
    wishListId: 0,

    dialogUseWishList: false,
    wishListKey: 0,
  });

  const setV2 = (v2) => {
    setV((prev) => {
      let ret = { ...prev, ...v2 };
      // dot.object(ret);
      return ret;
    });
  };

  const reqLogout = FetchLogin("logout", {
    data: {
      token: token,
    },
    callbackInit: () => {
      dispatch(setLoadingPage(true));
    },
    callback: (cb) => {
      dispatch(logout());
      dispatch(setLoadingPage(false));
    },
  });

  const reqBetLoad = FetchLogin("wishlist/load", {
    data: {
      token: token,
    },
    callbackInit: () => {},
    callback: (cb) => {
      setV2({ dialogLoadWishList: true, wishList: cb.response.data.bets });
    },
  });

  const reqBetDelete = FetchLogin("wishlist/delete", {
    data: {
      token: token,
      id: v.wishListId,
    },
    callbackInit: () => {},
    callback: (cb) => {
      setV2({ dialogDeleteWishList: false, wishList: cb.response.data.bets });
    },
  });

  return (
    <RetailerAccountTemplate title={"Account"}>
      <Withhold />
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          flexDirection: "column",
          height: 300,
          justifyContent: "space-between",
          marginTop: 50,
        }}
      >
        <Button onClick={() => hist.push("/deposit")}>Deposit</Button>
        <Button onClick={() => hist.push("/withdrawals")}>Withdrawals</Button>
        <Button onClick={() => hist.push("/credit-history")}>
          Transaction History
        </Button>
        <Button onClick={() => hist.push("/settings")}>Settings</Button>
        <Button onClick={() => reqBetLoad.handleTrigger()}>Wishlist</Button>
      </div>

      <Dialog open={v.dialogLoadWishList} maxWidth="sm">
        <div style={{ padding: "24px 36px", textAlign: "center" }}>
          <h3
            style={{ fontFamily: "arial", textAlign: "center", fontSize: 28 }}
          >
            Wishlist Load Menu
          </h3>
          <div style={{ marginBottom: 20 }}>
            {v.wishList.length > 0 ? (
              <ul className="wishlist-list">
                {v.wishList.map((a, aI) => {
                  return (
                    <li key={aI}>
                      <DeleteIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          v.dialogDeleteWishList = setV2({
                            dialogDeleteWishList: true,
                            wishListId: a.id,
                          });
                        }}
                      />
                      <span>{a.name}</span>
                      <ArrowForwardIosIcon
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setV2({ dialogUseWishList: true, wishListKey: aI })
                        }
                      />
                    </li>
                  );
                })}
              </ul>
            ) : (
              <span>No Saved Wishlist</span>
            )}
          </div>
          <Button
            style={{ fontSize: 12, padding: "8px 12px", background: "red" }}
            onClick={() => {
              setV2({ dialogLoadWishList: false });
            }}
          >
            Close
          </Button>
        </div>
      </Dialog>

      <Confirm
        open={v.dialogDeleteWishList}
        onClose={() => setV2({ dialogDeleteWishList: false })}
        question="Are you Sure? You want to Delete this"
        choices={[
          {
            title: "Confirm",
            onClick: () => {
              reqBetDelete.handleTrigger();
            },
          },
        ]}
      />

      <Confirm
        open={v.dialogUseWishList}
        onClose={() => setV2({ dialogUseWishList: false })}
        question="Add on Existing or Remove Others?"
        choice="3"
        choices={[
          {
            title: "Add on Existing",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });

              if (v.wishList[v.wishListKey].type === "4d") {
                dispatch(fourDPlaceBetAppendBoard(bets));
                hist.push("/place-bet");
              } else {
                dispatch(appendTotoPlaceBet(bets));
                hist.push("/toto");
              }
            },
          },
          {
            title: "Only This",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });

              if (v.wishList[v.wishListKey].type === "4d") {
                dispatch(fourDPlaceBetSetBoard(bets));
                hist.push("/place-bet");
              } else {
                dispatch(setTotoPlaceBet2(bets));
                hist.push("/toto");
              }
            },
          },
        ]}
      />

      <BottomFloat
        style={{
          background: "transparent",
          textAlign: "center",
          marginLeft: 0,
        }}
      >
        <Button onClick={() => reqLogout.handleTrigger()} color="secondary">
          Logout
        </Button>
      </BottomFloat>
    </RetailerAccountTemplate>
  );
}
